
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/subscriptions",
      function () {
        return require("private-next-pages/admin/subscriptions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/subscriptions"])
      });
    }
  